var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0003,
    cy: 13.5001,
    r: 10.8333,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1208 9.37145C19.337 9.58763 19.4927 9.85667 19.5726 10.1518C20.0324 12.0027 19.9262 14.9259 19.5815 16.8482C19.5017 17.1433 19.3459 17.4124 19.1297 17.6285C18.9135 17.8447 18.6445 18.0005 18.3494 18.0804C17.269 18.375 12.9208 18.375 12.9208 18.375C12.9208 18.375 8.57258 18.375 7.49223 18.0804C7.19712 18.0005 6.92807 17.8447 6.71189 17.6285C6.49572 17.4124 6.33994 17.1433 6.26008 16.8482C5.79758 15.0054 5.92437 12.0804 6.25116 10.1607C6.33101 9.8656 6.48679 9.59656 6.70297 9.38038C6.91915 9.1642 7.18819 9.00843 7.4833 8.92857C8.56366 8.63393 12.9119 8.625 12.9119 8.625C12.9119 8.625 17.2601 8.625 18.3404 8.91964C18.6355 8.9995 18.9046 9.15528 19.1208 9.37145ZM15.1351 13.5L11.5279 15.5893V11.4107L15.1351 13.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.61f6f99c79fee05ce791839e19f5fb53.svg";
export { ForwardRef as ReactComponent };